export const COLLECTOR_DOMAIN = "https://collector.subito.it";
export const COLLECTOR_PATH_BROWSER = "api/v1/track";
export const COLLECTOR_PATH_NODE = "api/v1/content";

export const SCHEMA_URL =
  "https://schema.adevinta.com/events/tracker-event.json/357.json";

export const DEFAULT_DEPLOY_STAGE = "pro";

export const ENVIRONMENT_ID_PREFIX = "sdrn:schibsted:environment:";

export const HOUSTON_URL_TEMPLATE = Object.freeze({
  dev: "https://api.houston-dev.advgo.net/v2/houston/experiments/%s",
  pre: "https://api.houston-pre.advgo.net/v2/houston/experiments/%s",
  pro: "https://api.houston.advgo.net/v2/houston/experiments/%s",
});

export const ACTIVATE_EVENT_KEY = "campaign_activated";
export const YELLOW_CAMPAIGN_KEY = "yellow";
